import React, { useContext } from 'react';
import { IconButton } from '@one-thd/sui-atomic-components';
import { TrashCan } from '@one-thd/sui-icons';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import { ProductListContext } from '../ProductListContext';

export const DeleteButton = ({
  itemId, intentId, groupId, iconSize, isReplaceModeItem, 'data-testid': testId
}) => {
  const {
    removeListItems, removeIntentItem, isRemoving, replacingItemId
  } = useContext(ProductListContext);

  const handleDelete = () => {
    if (!isRemoving) {
      // If this item is currently being replaced (indicated by prop, not ID pattern matching),
      // we need to delete the ORIGINAL item that was being replaced, not the ephemeral intent
      if (isReplaceModeItem && replacingItemId && removeListItems) {
        // Delete the original item that was being replaced
        removeListItems([replacingItemId]);
        return;
      }

      // If intentId is provided and it's a real intent (not ephemeral), delete the intent item
      if (intentId && removeIntentItem) {
        removeIntentItem({ groupId, intentId });
      } else if (itemId && removeListItems) {
        // Otherwise delete the regular item
        removeListItems([itemId]);
      }
    }
  };

  return (
    <IconButton
      icon={TrashCan}
      iconSize={iconSize}
      aria-label="Delete Item"
      disabled={isRemoving}
      onClick={handleDelete}
      data-testid={testId}
    />
  );
};

DeleteButton.propTypes = {
  itemId: string,
  intentId: string,
  groupId: string,
  iconSize: string,
  isReplaceModeItem: bool
};

DeleteButton.defaultProps = {
  itemId: null,
  intentId: null,
  groupId: null,
  iconSize: 'small',
  isReplaceModeItem: false
};
